// Local keyword/regex intent matcher for PROXY-shaped Ace queries. Ace's real
// freeform chat goes to a live Claude backend that has zero knowledge of
// PROXY mock data (extending it would require backend Python changes, out of
// scope for a frontend-mock feature) — so a handful of known phrasings are
// short-circuited here to a local, computed answer instead. Anything that
// doesn't match falls through to the real LLM unchanged.
import { PROXY_JOBS } from '../data/mockProxyJobs';

export type ProxyIntentHandler =
  | 'collectionsSummary' | 'draftRedFollowUps' | 'rdqNeeded' | 'cutoffThisWeek'
  | 'rdqCalculateForJob' | 'jobShortage' | 'contestsWaitingSignature';

export interface ProxyIntentMatch {
  handler: ProxyIntentHandler;
  params: Record<string, string>;
}

function jobExists(jobId: string): boolean {
  return PROXY_JOBS.some(j => j.jobId === jobId);
}

export function matchProxyIntent(text: string): ProxyIntentMatch | null {
  const t = text.trim();

  if (/collections?\s+summary/i.test(t)) return { handler: 'collectionsSummary', params: {} };

  let m = t.match(/draft\s+(?:red\s+)?follow-?ups?\s+for\s+(.+?)[.?!]*$/i);
  if (m) return { handler: 'draftRedFollowUps', params: { solicitor: m[1].trim() } };
  if (/draft\s+(?:red\s+)?follow-?ups?/i.test(t)) return { handler: 'draftRedFollowUps', params: {} };

  m = t.match(/(?:re)?calculate\s+rdq\s+for\s+job\s*#?(\w+)/i);
  if (m && jobExists(m[1])) return { handler: 'rdqCalculateForJob', params: { jobId: m[1] } };
  if (/rdq\s+needed/i.test(t)) return { handler: 'rdqNeeded', params: {} };

  m = t.match(/what'?s\s+short\s+on\s+job\s*#?(\w+)/i);
  if (m && jobExists(m[1])) return { handler: 'jobShortage', params: { jobId: m[1] } };

  m = t.match(/contests?.*waiting.*sign\w*.*past\s+(\d+)\s+days?/i);
  if (m) return { handler: 'contestsWaitingSignature', params: { days: m[1] } };

  if (/(vote\s+)?cutoff.*this\s+week/i.test(t)) return { handler: 'cutoffThisWeek', params: {} };

  return null;
}
